import { SET_USER_DATA, SET_USER_META_DATA } from "../actions/user";

const initialState = {
  uid: "",
  email: "",
  error: null,
  photoURL: "",
  metadata: {},
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return action.payload
        ? {
            ...action.payload,
          }
        : initialState;
    case SET_USER_META_DATA:
      return {
        ...state,
        metadata: action.payload,
      };
    default:
      return state;
  }
};

export default user;
